import { TJSSessionStorage  } from "#runtime/svelte/store/web-storage";

export const aaSessionStorage = new TJSSessionStorage();
